import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/seeker")({
  beforeLoad: () => {
    throw redirect({ to: "/candidate" })
  },
  component: () => null,
})
